import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import * as getters from './getters';
import dashboard from './modules/dashboard';
import customers from './modules/parties/customers';
import users from './modules/users';
import courses from './modules/courses/courses';
import coursesType from './modules/courses/courses-type';
import students from './modules/parties/students';
import partners from './modules/parties/partners';
import instructors from './modules/parties/instructors';
import collaborators from './modules/parties/collaborators';
import tenantCollaborators from './modules/parties/tenantCollaborators';
import payments from './modules/payments';
import parties from './modules/parties/parties';
import places from './modules/places';
import classes from './modules/classes/classes';
import classesAttendances from './modules/classes/attendances';
import classesGrades from './modules/classes/grades';
import certificates from './modules/certificates';
import classesFiles from './modules/classes/files';
import fileTypes from './modules/fileTypes';
import tenantUsers from './modules/tenant-users';
import { baseStore } from 'erp-skeleton-library/base-store/base-store';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    dashboard,
    customers,
    users,
    tenantUsers,
    courses,
    coursesType,
    students,
    partners,
    instructors,
    collaborators,
    parties,
    tenantCollaborators,
    places,
    payments,
    classes,
    classesAttendances,
    classesGrades,
    classesFiles,
    certificates,
    fileTypes,
    baseStore,
  },
  state,
  getters,
});

export default store;
